import { Coffee } from 'lucide-react';
import InventoryMaster from './InventoryMaster';

export default function CafeMaster({ user }) {
  return (
    <InventoryMaster
      user={user}
      masterType="cafe"
      apiPrefix="cafe-master"
      superCategory="Normal-Drinks"
      userRole="cafe"
      title="Cafe Master"
      Icon={Coffee}
      iconColor="text-amber-600"
      emptyMessage="No approved drinks items found in Price Master"
    />
  );
}
